export default "__VITE_ASSET__996716d3__"